// extracted by mini-css-extract-plugin
module.exports = {"advantageCard":"_2r3Eam","modalOpen":"_38SFKb","heading":"_3onvVZ","icon":"_2gvFgI","modal":"hQF3-Z","readmore":"wNdVGQ","modalBody":"_9haKC7"};